export const APP_RATE_SUBMITTED = 'app_rate_submitted';
export const APP_RATE_REMINDER = 'app_rate_reminder';
